(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection-custom"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Handle bundle direct add to cart
  document.querySelectorAll('.js-add-to-cart-bundle').forEach(button => {
    button.addEventListener('click', function() {
      const variantId = this.getAttribute('data-variant-id');
      const quantity = parseInt(this.getAttribute('data-quantity')) || 1;

      // Add to cart using Shopify AJAX API
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: quantity
          }]
        })
      })
      .then(response => response.json())
      .then(data => {
        // Open cart drawer after successful add
        const cartDrawer = document.querySelector('[data-wau-slideout-target="ajax-cart"]');
        if (cartDrawer) {
          cartDrawer.click();
        }
      })
      .catch((error) => {
        console.error('Error:', error);
        alert('There was an error adding the product to your cart. Please try again.');
      });
    });
  });

  // Handle modal open/close
  document.querySelectorAll('.js-open-modal').forEach(button => {
    button.addEventListener('click', function() {
      const modalId = this.getAttribute('data-modal-target');
      const modal = document.getElementById(modalId);
      if (modal) {
        modal.style.display = 'block';
        document.body.style.overflow = 'hidden';
      }
    });
  });

  // Handle modal close
  document.querySelectorAll('.close-modal').forEach(button => {
    button.addEventListener('click', function() {
      const modal = this.closest('.product-modal');
      if (modal) {
        modal.style.display = 'none';
        document.body.style.overflow = '';
      }
    });
  });

  // Close modal when clicking outside
  document.querySelectorAll('.product-modal').forEach(modal => {
    modal.addEventListener('click', function(e) {
      if (e.target === this) {
        this.style.display = 'none';
        document.body.style.overflow = '';
      }
    });
  });

  // Handle quantity buttons
  document.querySelectorAll('.quantity-btn').forEach(button => {
    button.addEventListener('click', function() {
      const input = this.parentNode.querySelector('.quantity-input');
      const currentValue = parseInt(input.value) || 1;
      
      if (this.classList.contains('plus')) {
        input.value = currentValue + 1;
      } else if (this.classList.contains('minus') && currentValue > 1) {
        input.value = currentValue - 1;
      }
    });
  });

  // Handle modal form submission
  document.querySelectorAll('.modal-form').forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      
      const formData = new FormData(this);
      const variantId = formData.get('id');
      const quantity = parseInt(formData.get('quantity')) || 1;
      const sellingPlan = formData.get('selling_plan');

      // Prepare cart data
      const cartData = {
        items: [{
          id: variantId,
          quantity: quantity
        }]
      };

      // Add selling plan if selected
      if (sellingPlan) {
        cartData.items[0].selling_plan = sellingPlan;
      }

      // Add to cart using Shopify AJAX API
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(cartData)
      })
      .then(response => response.json())
      .then(data => {
        // Close modal
        const modal = this.closest('.product-modal');
        if (modal) {
          modal.style.display = 'none';
          document.body.style.overflow = '';
        }
        
        // Open cart drawer after successful add
        const cartDrawer = document.querySelector('[data-wau-slideout-target="ajax-cart"]');
        if (cartDrawer) {
          cartDrawer.click();
        }
      })
      .catch((error) => {
        console.error('Error:', error);
        alert('There was an error adding the product to your cart. Please try again.');
      });
    });
  });

  // Initialize Seal Subscriptions
  if (window.SealSubscriptions) {
    window.SealSubscriptions.init();
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-custom"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {

  // Handle bundle direct add to cart
  document.querySelectorAll('.js-add-to-cart-bundle').forEach(button => {
    button.addEventListener('click', function() {
      const variantId = this.getAttribute('data-variant-id');
      const quantity = parseInt(this.getAttribute('data-quantity')) || 1;

      // Add to cart using Shopify AJAX API
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: quantity
          }]
        })
      })
      .then(response => response.json())
      .then(data => {
        // Open cart drawer after successful add
        const cartDrawer = document.querySelector('[data-wau-slideout-target="ajax-cart"]');
        if (cartDrawer) {
          cartDrawer.click();
        }
      })
      .catch((error) => {
        console.error('Error:', error);
        alert('There was an error adding the product to your cart. Please try again.');
      });
    });
  });

  // Handle modal open/close
  document.querySelectorAll('.js-open-modal').forEach(button => {
    button.addEventListener('click', function() {
      const modalId = this.getAttribute('data-modal-target');
      const modal = document.getElementById(modalId);
      if (modal) {
        modal.style.display = 'block';
        document.body.style.overflow = 'hidden';
      }
    });
  });

  // Handle modal close
  document.querySelectorAll('.pt-close-modal').forEach(button => {
    button.addEventListener('click', function() {
      const modal = this.closest('.purple-tree-modal');
      if (modal) {
        modal.style.display = 'none';
        document.body.style.overflow = '';
      }
    });
  });

  // Close modal when clicking outside
  document.querySelectorAll('.purple-tree-modal').forEach(modal => {
    modal.addEventListener('click', function(e) {
      if (e.target === this) {
        this.style.display = 'none';
        document.body.style.overflow = '';
      }
    });
  });

  // Handle quantity buttons
  document.querySelectorAll('.pt-quantity-btn').forEach(button => {
    button.addEventListener('click', function() {
      const input = this.parentNode.querySelector('.pt-quantity-input');
      const currentValue = parseInt(input.value) || 1;
      
      if (this.classList.contains('plus')) {
        input.value = currentValue + 1;
      } else if (this.classList.contains('minus') && currentValue > 1) {
        input.value = currentValue - 1;
      }
    });
  });

  // Handle modal form submission
  document.querySelectorAll('.modal-form').forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      
      const formData = new FormData(this);
      const variantId = formData.get('id');
      const quantity = parseInt(formData.get('quantity')) || 1;
      const sellingPlan = formData.get('selling_plan');

      // Prepare cart data
      const cartData = {
        items: [{
          id: variantId,
          quantity: quantity
        }]
      };

      // Add selling plan if selected
      if (sellingPlan) {
        cartData.items[0].selling_plan = sellingPlan;
      }

      // Add to cart using Shopify AJAX API
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(cartData)
      })
      .then(response => response.json())
      .then(data => {
        // Close modal
        const modal = this.closest('.product-modal');
        if (modal) {
          modal.style.display = 'none';
          document.body.style.overflow = '';
        }
        
        // Open cart drawer after successful add
        const cartDrawer = document.querySelector('[data-wau-slideout-target="ajax-cart"]');
        if (cartDrawer) {
          cartDrawer.click();
        }
      })
      .catch((error) => {
        console.error('Error:', error);
        alert('There was an error adding the product to your cart. Please try again.');
      });
    });
  });

  // Initialize Seal Subscriptions
  if (window.SealSubscriptions) {
    window.SealSubscriptions.init();
  }
});

  } catch(e) { console.error(e); }
})();
})();
